// Backend akzeptiert und gibt zurück (case-insensitive, wird normalisiert):
const VALID_BE_VALUES = new Set([
  "Trainee",
  "kurzfristig",
  "Minijob",
  "Werkstudent",
  "Teilzeit",
  "Vollzeit",
]);

// Normalisierungs-Map (verschiedene Schreibweisen → Backend-Format)
const NORMALIZE_MAP: Record<string, string> = {
  "TRAINEE": "Trainee",
  "trainee": "Trainee",
  "KURZFRISTIG": "kurzfristig",
  "MINIJOB": "Minijob",
  "minijob": "Minijob",

  // UI-Labels → Backend-Format
  "Kurzfristig beschäftigt": "kurzfristig",
  "Kurzfristig": "kurzfristig",
};

export function toServerEmploymentType(uiValue?: string | null): string | null {
  if (!uiValue) return null;
  const trimmed = uiValue.trim();

  // Wenn bereits im Backend-Format → direkt zurückgeben
  if (VALID_BE_VALUES.has(trimmed)) {
    return trimmed;
  }

  // Versuche zu normalisieren
  const normalized = NORMALIZE_MAP[trimmed];
  if (normalized && VALID_BE_VALUES.has(normalized)) {
    return normalized;
  }

  // Ungültiger Wert → null (mit Warnung)
  console.warn('[profile_value_mapping] Unknown employment type:', trimmed, '- returning null');
  return null;
}

// --- Gender Normalization ---

const VALID_GENDERS = new Set(['m', 'w', 'd', 'x']);

const GENDER_NORMALIZE_MAP: Record<string, string> = {
  "MALE": "m",
  "Male": "m",
  "male": "m",
  "M": "m",
  "männlich": "m",
  "Männlich": "m",
  "FEMALE": "w",
  "Female": "w",
  "female": "w",
  "F": "w",
  "W": "w",
  "weiblich": "w",
  "Weiblich": "w",
  "DIVERSE": "d",
  "Diverse": "d",
  "diverse": "d",
  "divers": "d",
  "Divers": "d",
  "D": "d",
  "X": "x",
  "x": "x",
};

export function normalizeGender(raw?: string | null): string | null {
  if (!raw) return null;
  const trimmed = raw.trim();
  if (VALID_GENDERS.has(trimmed)) return trimmed;
  const normalized = GENDER_NORMALIZE_MAP[trimmed];
  if (normalized) return normalized;
  console.warn('[profile_value_mapping] Unknown gender:', trimmed, '- returning null');
  return null;
}
